var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.907,
    height: 18.94,
    viewBox: "0 0 18.907 18.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.575,4.717a4.022,4.022,0,0,1,3.177,3.177M13.575,1.5a7.239,7.239,0,0,1,6.395,6.387m-.8,6.419v2.413a1.609,1.609,0,0,1-1.753,1.609,15.918,15.918,0,0,1-6.942-2.469,15.685,15.685,0,0,1-4.826-4.826A15.918,15.918,0,0,1,3.174,4.058,1.609,1.609,0,0,1,4.775,2.3H7.188A1.609,1.609,0,0,1,8.8,3.688a10.328,10.328,0,0,0,.563,2.26A1.609,1.609,0,0,1,9,7.645L7.976,8.667A12.87,12.87,0,0,0,12.8,13.493l1.022-1.022a1.609,1.609,0,0,1,1.7-.362,10.328,10.328,0,0,0,2.26.563A1.609,1.609,0,0,1,19.165,14.305Z",
    transform: "translate(-2.167 -0.396)",
    fill: "none",
    stroke: "#686868",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.028fc1aae719e621ff270ea780703202.svg";
export { ForwardRef as ReactComponent };